import ClipIcon from "../../assets/paperclip.svg";
import ScrapIcon from "../../assets/scrap.svg";
import GlassesIcon from "../../assets/glasses.svg";
import { FruitType } from "../../context";

interface MessageContent {
	title: string;
	text: string;
}

export interface EForm {
	name?: string;
	born?: string;
	age: string;
	hard?: string;
	achivment?: string;
	isAcceptCorret: boolean;
	accept: MessageContent;
	decline?: MessageContent;
}

interface FruitResumeData {
	name: string;
	title: string;
	body: string;
	body2: string;
	instruction: string;
	winners: string[];
	forms: EForm[];
}

type FruitsResumeDataset = {
	[key in FruitType]: FruitResumeData;
};
export const fruitsResumeData: FruitsResumeDataset = {
	cake: {
		name: "Корзиночка",
		title: "вСтРечаем пО резЮме",
		body: "Узнайте, что пишут о своём составе кандидаты.",
		body2:
			"Не дайте себя провести — нам нужны самые чистые и честные, остальных отправим обратно",
		instruction:
			"Перед вами резюме пяти корзиночек с кремом. Жмите «На полку» или «На выход», чтобы оставить троих кандидатов",
		winners: ["2", "3", "5"],
		forms: [
			{
				name: 'КорЗинкИн',
				born: "Долгожитель",
				age: "9 дней",
				achivment: "Вошел в топ-60\nконкурса «Десерт\n года»",
				isAcceptCorret: false,
				accept: {
					title: "А вОзрасТ ваС нЕ сМуТил?",
					text: "Что-то тут нечисто: 9 дней – большой срок для натурального пирожного. Скорее всего, есть консерванты – не будем рисковать",
				},
				decline: {
					title: "Вас тОЖе воЗрасТ смУтиЛ?",
					text: "Что-то тут нечисто: 9 дней – большой срок для натурального пирожного. Скорее всего, есть консерванты – не будем рисковать",
				},
			},
			{
				name: "МаСлОва",
				born: "Влюбляю людей\n в десерты",
				age: "1 день",
				achivment: "Нежный крем\nиз сливочного масла",
				isAcceptCorret: true,
				accept: {
					title: "НаС Она тоЖе покОрИла!",
					text: "У подходящей корзиночки крем только таким и должен быть. Кандидатов с кремом из пальмового масла мы не рассматриваем",
				},
				decline: {
					title: "ПрИсмОтРитЕсь ЕщЁ раЗоК",
					text: "У подходящей корзиночки крем должен быть только из сливочного масла. Никакого пальмового!",
				},
			},
			{
				name: "МалИниНа",
				born: "Стабильна\n без стабилизаторов",
				achivment: "Вкус пирожного\n из детства",
				age: "2,5 дня",
				isAcceptCorret: true,
				accept: {
					title: "ОтЛичНое реЗюмЕ!",
					text: "В масляные кремы часто добавляют стабилизаторы. Мы соблюдаем рецепт и условия хранения, поэтому крем не расслаивается",
				},
				decline: {
					title: "ЗрЯ вЫ таК",
					text: "В масляные кремы часто добавляют стабилизаторы. Мы соблюдаем рецепт и условия хранения, поэтому крем не расслаивается",
				},
			},
			{
				name: 'наЧИнКиНа',
				born: "Покоряю шлейфом",
				age: "2 дня",
				achivment: "Яркий ягодный\n аромат",
				isAcceptCorret: false,
				accept: {
					title: "Вас сБиЛи С тОлкУ",
					text: "Яркий запах намекает на то, что производитель ради экономии добавил химии. В наших корзиночках за аромат отвечают только ягоды",
				},
				decline: {
					title: "Чуть Не сбИла с ТолКу, да?",
					text: "Яркий запах намекает на то, что производитель ради экономии добавил химии. В наших корзиночках за аромат отвечают только ягоды",
				},
			},
			{
				name: 'ВкУсНиЦина',
				born: "Сама натуральность",
				age: "3 дня",
				achivment: "Лучшее песочное\n тесто в городе",
				isAcceptCorret: true,
				accept: {
					title: "ОдоБряеМ на вСе стО!",
					text: "У кандидата чистая репутация — в связях с консервантами, искусственными красителями и заменителями молочного жира не замечен. Натуральный состав плюс вкусное тесто — это мэтч!",
				},
				decline: {
					title: "А наМ Она НраВиТсЯ!",
					text: "У кандидата чистая репутация — в связях с консервантами, искусственными красителями и заменителями молочного жира не замечен. Натуральный состав плюс вкусное тесто — это мэтч!",
				},
			},
		],
	},
	sausage: {
		name: "Колбаса",
		title: "вСтРечаем пО резЮме",
		body: "Узнайте, что пишут о своём составе кандидаты.",
		body2:
			"Не дайте себя провести — нам нужны самые чистые и честные, остальных отправим обратно",
		instruction:
			"Перед вами резюме пяти деловых колбас. Жмите «На полку» или «На выход», чтобы оставить троих кандидатов",
		winners: ["1", "2", "4"],
		forms: [
			{
				name: 'НахлЕбнИкоВ',
				born: "Добрый и совсем\nне вредный",
				age: "14 дней",
				achivment: "Прошёл все\nлабораторные\nпроверки",
				isAcceptCorret: true,
				accept: {
					title: "ПодДерЖиваеМ, наМ она ТоЖе нРавИтСя",
					text: "Нас колбасой не корми, дай проверку провести — за день можем устроить 8 аудитов поставщиков, за месяц — более 40 000 внутренних лабораторных тестов",
				},
				decline: {
					title: "ПредЛагаеМ пРИсМотРеТьСя ещЁ раЗ",
					text: "Нас колбасой не корми, дай проверку провести — за день можем устроить 8 аудитов поставщиков, за месяц — более 40 000 внутренних лабораторных тестов",
				},
			},
			{
				name: "КоЛбасЕнКО",
				born: "Ценю простоту",
				age: "5 дней",
				achivment: "100% чистого мяса,\n 0% заменителей",
				isAcceptCorret: true,
				accept: {
					title: "СоГласНы, ЭтО ПеРсПекТивНыЙ КаНдИдат",
					text: "Мы тоже считаем, что чем проще и понятнее состав, тем продукт безопаснее, полезнее и вкуснее. В правильной колбасе — максимум мяса и ноль лишних добавок",
				},
				decline: {
					title: "Вас СмУтИла ПрОсТоТа канДидата? Не сОгласНы!",
					text: "Мы тоже считаем, что чем проще и понятнее состав, тем продукт безопаснее, полезнее и вкуснее. В правильной колбасе — максимум мяса и ноль лишних добавок",
				},
			},
			{
				name: "ДобаВкИна",
				born: "Не отказываю\nсебе в добавках",
				achivment: "Аппетитный розовый\n цвет",
				age: "25 дней",
				isAcceptCorret: false,
				accept: {
					title: "КаЖеТсЯ, вЫ ПоТоРоПиЛиСь",
					text: "Продолжительный срок годности и насыщенный цвет намекают, что в составе есть нитрит натрия (E250) — нам такого не надо",
				},
				decline: {
					title: "Вы ПравЫ, ЭтО ЯвНо нЕ наш канДиДаТ",
					text: "Продолжительный срок годности и насыщенный цвет намекают, что в составе есть нитрит натрия (E250) — нам такого не надо",
				},
			},
			{
				name: 'СлИвоЧкина',
				born: "Очень нежная",
				age: "12 дней",
				achivment: "Обожаю\nнатуральные сливки\nи молоко",
				isAcceptCorret: true,
				accept: {
					title: "ОдоБрЯеМ ваШ вЫбОр!",
					text: "Сразу видно хороший вкус — молочный. У колбасы идеальная репутация, и мы это ценим, ведь наша жалобная книга пуста — негативных отзывов всего 0,1 %"
				},
				decline: {
					title: "В чЁм засОмНеВалИсь?",
					text: "Тут сразу видно хороший вкус — молочный. У колбасы идеальная репутация, и мы это ценим, ведь наша жалобная книга пуста — негативных отзывов всего 0,1 %"
				},
			},
			{
				name: 'НарЕзкИн',
				born: "Полный фарш",
				age: "17 дней",
				achivment: "Очень |s|пере|/s|прорабо-\nтанный",
				isAcceptCorret: false,
				accept: {
					title: "ЭтогО канДидата ТочнО НужнО забракоВать!",
					text: "Мясо механической обвалки (ММО) получают, измельчая кости и оставшиеся на них ткани. ММО дешевле мяса, но уступает ему в пищевой ценности"
				},
				decline: {
					title: "Этот канДидат нам Не пОДхОдит",
					text: "Мясо механической обвалки (ММО) получают, измельчая кости и оставшиеся на них ткани. ММО дешевле мяса, но уступает ему в пищевой ценности"
				},
			},
		],
	},
	roll: {
		name: "РОлЛ",
		title: "вСтРечаем пО резЮме",
		body: "Узнайте, что пишут о своём составе кандидаты.",
		body2:
			"Не дайте себя провести — нам нужны самые чистые и честные, остальных отправим обратно",
		instruction:
			"Перед вами резюме пяти сэндвич-роллов «Цезарь». Жмите «На полку» или «На выход», чтобы оставить троих кандидатов",
		winners: ["1", "3", "5"],
		forms: [
			{
				name: 'АпПетиДзе',
				born: "Перфекционистка",
				age: "15 часов",
				achivment: "Мой соус —\n идеальный: майонез,\n соевый, анчоусы\n и чесночок!",
				isAcceptCorret: true,
				accept: {
					title: "ПреКраснЫй выБор!",
					text: "Мы тоже перфекционисты — можем дорабатывать рецепт соуса месяцами, пока не получим совершенство",
				},
				decline: {
					title: "Зачем жЕ вЫ так!",
					text: "Мы тоже перфекционисты — можем дорабатывать рецепт соуса месяцами, пока не получим совершенство",
				},
			},
			{
				name: "УмамиН",
				born: "Ради умами готов на всё",
				age: "20 часов",
				achivment: "Насыщенный вкус",
				isAcceptCorret: false,
				accept: {
					title: "А вам оН нЕ кажеТся подОзрИтеЛьнЫм?",
					text: "Чтобы получить насыщенный мясной вкус — умами, — некоторые производители используют глутамат натрия. А мы за естественность: используем только качественное куриное мясо и анчоусы",
				},
				decline: {
					title: "Нам оН тоЖе кажЕтсЯ поДозРитЕльНым!",
					text: "Чтобы получить насыщенный мясной вкус — умами, — некоторые производители используют глутамат натрия. А мы за естественность: используем только качественное куриное мясо и анчоусы",
				},
			},
			{
				name: "ЦезареВич",
				born: "Фрешмен",
				achivment: "Самый хрустящий\n салат",
				age: "10 часов",
				isAcceptCorret: true,
				accept: {
					title: "Вы ПраВы, эТо цеНнЫй каДр!",
					text: "Овощи и зелень в наших продуктах выращены без лишней химии. Мы проверяем их на 224 пестицида, а другие – только на 6",
				},
				decline: {
					title: "ЗРя вЫ, эТо цеНнЫй каДр!",
					text: "Овощи и зелень в наших продуктах выращены без лишней химии. Мы проверяем их на 224 пестицида, а другие – только на 6",
				},
			},
			{
				name: "ПереКусоВа",
				born: 'Не боюсь плесени',
				achivment: "Заряжена мягким\nчеддером",
				age: "30 часов",
				isAcceptCorret: false,
				accept: {
					title: "ПоДвоХ разГлЯдЕть трУдНо, нО Он еСтЬ",
					text: "Некоторые сыры обрабатывают натамицином, чтобы дольше не плесневели. Мы так не делаем. В составе наших сыров — только молоко, закваска, фермент и соль. Ничего лишнего",
				},
				decline: {
					title: "Вау, вас не проведёшь!",
					text: "Некоторые сыры обрабатывают натамицином, чтобы дольше не плесневели. Мы так не делаем. В составе наших сыров — только молоко, закваска, фермент и соль. Ничего лишнего",
				},
			},
			{
				name: 'Лавашова',
				born: "Не принимаю добавки",
				age: "7 часов",
				achivment: "Рекордно мягкий\nлаваш",
				isAcceptCorret: true,
				accept: {
					title: "ПриГлаШаем еГо вО втОроЙ этап!",
					text: "Мы тоже против лишних добавок: в наших сэндвич-роллах нет усилителей вкуса, пищевых ароматизаторов, консервантов и антибиотиков — только чистые, вкусные продукты",
				},
				decline: {
					title: "ЛучШе прИгласиМ еГо вО втОроЙ этап!",
					text: "Мы тоже против лишних добавок: в наших сэндвич-роллах нет усилителей вкуса, пищевых ароматизаторов, консервантов и антибиотиков — только чистые, вкусные продукты",
				},
			},
		],
	},
};

export const fruitsIcon = [
	{
		icon: ClipIcon,
		iconPos: "-bottom-2 left-2.5 short:bottom-2",
	},
	{
		icon: "",
		iconPos: "-bottom-[40px] left-[-5px] short:-bottom-14",
		img: "/images/interview/pen.webp",
	},
	{
		icon: ScrapIcon,
		iconPos: "-bottom-2 left-2.5",
	},
	{
		icon: GlassesIcon,
		iconPos: "-bottom-10 -left-10 short:bottom-0 short:-left-14",
	},
	{
		icon: ClipIcon,
		iconPos: "-bottom-5 left-2.5 short:bottom-5",
	},
];
